import React from 'react'
import { Container } from 'reactstrap'
import { Theme, Badge } from '@pga/pga-component-library'
import imgSrc from '../../../../../assets/images/set-preferences-cta2.jpg'
import {
  StyledContainer,
  StyledActionSection,
  StyledInfo,
  StyledImg,
  StyledImgWrapper,
  StyledImgText,
  StyledImgSpanText,
  StyledTitle,
  StyledButton,
  StyledLink,
  StyledSecondaryInfo
} from './styles'

export default () => {
  return (
    <Container>
      <StyledContainer>
        <StyledActionSection>
          <StyledTitle>Set your preferences to see jobs that match your career interests.</StyledTitle>
          <StyledInfo>
            Those with an existing pga.org account can login to set job preferences, allowing you to see positions that match your interests, locations, pay and more.
          </StyledInfo>
          <StyledLink href='https://account.pga.org/job-preferences'>
            <StyledButton>Set Job Preferences</StyledButton>
          </StyledLink>
          <StyledSecondaryInfo>(Existing Account Required)</StyledSecondaryInfo>
        </StyledActionSection>
        <StyledImgWrapper>
          <StyledImg src={imgSrc} alt='Recommended job' />
          <StyledImgText>
            <Badge color={Theme.colors.lightBlue}>Recommended For You</Badge>
            <StyledImgSpanText>1 day ago</StyledImgSpanText>
            <p>Assistant Professional</p>
          </StyledImgText>
        </StyledImgWrapper>

      </StyledContainer>
    </Container>
  )
}
